import type { TypedUseSelectorHook } from 'react-redux';
import { useSelector, useDispatch } from 'react-redux';
import type { ThunkAction, ThunkDispatch } from 'redux-thunk';
import type { Action, AnyAction, Dispatch } from 'redux';

import type { RootState } from './main';
import type { AsyncAction, Action as CustomAction } from '../../types/actions';

export const useTypedSelector: TypedUseSelectorHook<RootState> = useSelector;

export const useAppDispatch: <AppDispatch extends Dispatch<AnyAction | CustomAction> = Dispatch<AnyAction | CustomAction>>() => AppDispatch = useDispatch;

export type ThunkDispatchType = ThunkDispatch<RootState, unknown, Action | AsyncAction>;

export const useThunkDispatch: () => ThunkDispatchType = useDispatch;

export type AppThunk<ReturnType = void> = ThunkAction<
	ReturnType,
	RootState,
	unknown,
	AnyAction
>;
